/**
 * VuePrint v1.6.3
 * Copyright (c) 2024 Jak Guru LLC
 * Vueprint a commerical work product released under the MIT License
 * and is provided as-is with no warranty or guarantee of support.
 * Documentation: https://jakguru.github.io/vueprint/
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, getToken } from 'firebase/messaging';
import { c as commonjsGlobal, g as getDefaultExportFromCjs } from './vueprint.22af4dba.mjs';
import { ref, computed, watch } from 'vue';
import { B as BusService } from './vueprint.1f7141fe.mjs';
import { g as getDebugger } from './vueprint.b84f56b4.mjs';
import { L as LocalStorageService } from './vueprint.19cdf2cc.mjs';
import { I as IdentityService } from './vueprint.c6b8bf52.mjs';
import { M as MiliCron } from './vueprint.5d216d52.mjs';
import { i as isAxiosInstance } from './vueprint.fd68f7a1.mjs';

var push_min = {exports: {}};

/**
 * @license
 *
 * Push v1.0.9
 * =========
 * A compact, cross-browser solution for the JavaScript Notifications API
 *
 * Credits
 * -------
 * Tsvetan Tsvetkov (ttsvetko)
 * Alex Gibson (alexgibson)
 *
 * License
 * -------
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015-2017 Tyler Nickerson
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

(function (module, exports) {
	!function(i,t){module.exports=t();}(commonjsGlobal,function(){var i={errors:{incompatible:"".concat("PushError:"," Push.js is incompatible with browser."),invalid_plugin:"".concat("PushError:"," plugin class missing from plugin manifest (invalid plugin). Please check the documentation."),invalid_title:"".concat("PushError:"," title of notification must be a string"),permission_denied:"".concat("PushError:"," permission request declined"),sw_notification_error:"".concat("PushError:"," could not show a ServiceWorker notification due to the following reason: "),sw_registration_error:"".concat("PushError:"," could not register the ServiceWorker due to the following reason: "),unknown_interface:"".concat("PushError:"," unable to create notification: unknown interface")}};function t(i){return (t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(i){return typeof i}:function(i){return i&&"function"==typeof Symbol&&i.constructor===Symbol&&i!==Symbol.prototype?"symbol":typeof i})(i)}function n(i,t){if(!(i instanceof t))throw new TypeError("Cannot call a class as a function")}function e(i,t){for(var n=0;n<t.length;n++){var e=t[n];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(i,e.key,e);}}function o(i,t,n){return t&&e(i.prototype,t),n&&e(i,n),i}function r(i,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");i.prototype=Object.create(t&&t.prototype,{constructor:{value:i,writable:!0,configurable:!0}}),t&&c(i,t);}function s(i){return (s=Object.setPrototypeOf?Object.getPrototypeOf:function(i){return i.__proto__||Object.getPrototypeOf(i)})(i)}function c(i,t){return (c=Object.setPrototypeOf||function(i,t){return i.__proto__=t,i})(i,t)}function a(i,t){return !t||"object"!=typeof t&&"function"!=typeof t?function(i){if(void 0===i)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return i}(i):t}var u=function(){function i(t){n(this,i),this._win=t,this.GRANTED="granted",this.DEFAULT="default",this.DENIED="denied",this._permissions=[this.GRANTED,this.DEFAULT,this.DENIED];}return o(i,[{key:"request",value:function(i,t){return arguments.length>0?this._requestWithCallback.apply(this,arguments):this._requestAsPromise()}},{key:"_requestWithCallback",value:function(i,t){var n,e=this,o=this.get(),r=!1,s=function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e._win.Notification.permission;r||(r=!0,void 0===n&&e._win.webkitNotifications&&(n=e._win.webkitNotifications.checkPermission()),n===e.GRANTED||0===n?i&&i():t&&t());};o!==this.DEFAULT?s(o):this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission?this._win.webkitNotifications.requestPermission(s):this._win.Notification&&this._win.Notification.requestPermission?(n=this._win.Notification.requestPermission(s))&&n.then&&n.then(s).catch(function(){t&&t();}):i&&i();}},{key:"_requestAsPromise",value:function(){var i=this,t=this.get(),n=t!==this.DEFAULT,e=this._win.Notification&&this._win.Notification.requestPermission,o=this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission;return new Promise(function(r,s){var c,a=!1,u=function(t){a||(a=!0,!function(t){return t===i.GRANTED||0===t}(t)?s():r());};n?u(t):o?i._win.webkitNotifications.requestPermission(function(i){u(i);}):e?(c=i._win.Notification.requestPermission(u))&&c.then&&c.then(u).catch(s):r();})}},{key:"has",value:function(){return this.get()===this.GRANTED}},{key:"get",value:function(){return this._win.Notification&&this._win.Notification.permission?this._win.Notification.permission:this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission?this._permissions[this._win.webkitNotifications.checkPermission()]:navigator.mozNotification?this.GRANTED:this._win.external&&this._win.external.msIsSiteMode?this._win.external.msIsSiteMode()?this.GRANTED:this.DEFAULT:this.GRANTED}}]),i}(),f=function(){function i(){n(this,i);}return o(i,null,[{key:"isUndefined",value:function(i){return void 0===i}},{key:"isNull",value:function(i){return null===obj}},{key:"isString",value:function(i){return "string"==typeof i}},{key:"isFunction",value:function(i){return i&&"[object Function]"==={}.toString.call(i)}},{key:"isObject",value:function(i){return "object"===t(i)}},{key:"objectMerge",value:function(i,t){for(var n in t)i.hasOwnProperty(n)&&this.isObject(i[n])&&this.isObject(t[n])?this.objectMerge(i[n],t[n]):i[n]=t[n];}}]),i}(),l=function i(t){n(this,i),this._win=t;},h=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.Notification}},{key:"create",value:function(i,t){return new this._win.Notification(i,{icon:f.isString(t.icon)||f.isUndefined(t.icon)||f.isNull(t.icon)?t.icon:t.icon.x32,body:t.body,tag:t.tag,requireInteraction:t.requireInteraction})}},{key:"close",value:function(i){i.close();}}]),t}(),_=function(t){function e(){return n(this,e),a(this,s(e).apply(this,arguments))}return r(e,l),o(e,[{key:"isSupported",value:function(){return void 0!==this._win.navigator&&void 0!==this._win.navigator.serviceWorker}},{key:"getFunctionBody",value:function(i){var t=i.toString().match(/function[^{]+{([\s\S]*)}$/);return null!=t&&t.length>1?t[1]:null}},{key:"create",value:function(t,n,e,o,r){var s=this;this._win.navigator.serviceWorker.register(o),this._win.navigator.serviceWorker.ready.then(function(o){var c={id:t,link:e.link,origin:document.location.href,onClick:f.isFunction(e.onClick)?s.getFunctionBody(e.onClick):"",onClose:f.isFunction(e.onClose)?s.getFunctionBody(e.onClose):""};void 0!==e.data&&null!==e.data&&(c=Object.assign(c,e.data)),o.showNotification(n,{icon:e.icon,body:e.body,vibrate:e.vibrate,tag:e.tag,data:c,requireInteraction:e.requireInteraction,silent:e.silent}).then(function(){o.getNotifications().then(function(i){o.active.postMessage(""),r(i);});}).catch(function(t){throw new Error(i.errors.sw_notification_error+t.message)});}).catch(function(t){throw new Error(i.errors.sw_registration_error+t.message)});}},{key:"close",value:function(){}}]),e}(),v=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.navigator.mozNotification}},{key:"create",value:function(i,t){var n=this._win.navigator.mozNotification.createNotification(i,t.body,t.icon);return n.show(),n}}]),t}(),d=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.external&&void 0!==this._win.external.msIsSiteMode}},{key:"create",value:function(i,t){return this._win.external.msSiteModeClearIconOverlay(),this._win.external.msSiteModeSetIconOverlay(f.isString(t.icon)||f.isUndefined(t.icon)?t.icon:t.icon.x16,i),this._win.external.msSiteModeActivate(),null}},{key:"close",value:function(){this._win.external.msSiteModeClearIconOverlay();}}]),t}(),w=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.webkitNotifications}},{key:"create",value:function(i,t){var n=this._win.webkitNotifications.createNotification(t.icon,i,t.body);return n.show(),n}},{key:"close",value:function(i){i.cancel();}}]),t}();return new(function(){function t(i){n(this,t),this._currentId=0,this._notifications={},this._win=i,this.Permission=new u(i),this._agents={desktop:new h(i),chrome:new _(i),firefox:new v(i),ms:new d(i),webkit:new w(i)},this._configuration={serviceWorker:"/serviceWorker.min.js",fallback:function(i){}};}return o(t,[{key:"_closeNotification",value:function(t){var n=!0,e=this._notifications[t];if(void 0!==e){if(n=this._removeNotification(t),this._agents.desktop.isSupported())this._agents.desktop.close(e);else if(this._agents.webkit.isSupported())this._agents.webkit.close(e);else {if(!this._agents.ms.isSupported())throw n=!1,new Error(i.errors.unknown_interface);this._agents.ms.close();}return n}return !1}},{key:"_addNotification",value:function(i){var t=this._currentId;return this._notifications[t]=i,this._currentId++,t}},{key:"_removeNotification",value:function(i){var t=!1;return this._notifications.hasOwnProperty(i)&&(delete this._notifications[i],t=!0),t}},{key:"_prepareNotification",value:function(i,t){var n,e=this;return n={get:function(){return e._notifications[i]},close:function(){e._closeNotification(i);}},t.timeout&&setTimeout(function(){n.close();},t.timeout),n}},{key:"_serviceWorkerCallback",value:function(i,t,n){var e=this,o=this._addNotification(i[i.length-1]);navigator&&navigator.serviceWorker&&(navigator.serviceWorker.addEventListener("message",function(i){var t=JSON.parse(i.data);"close"===t.action&&Number.isInteger(t.id)&&e._removeNotification(t.id);}),n(this._prepareNotification(o,t))),n(null);}},{key:"_createCallback",value:function(i,t,n){var e,o=this,r=null;if(t=t||{},e=function(i){o._removeNotification(i),f.isFunction(t.onClose)&&t.onClose.call(o,r);},this._agents.desktop.isSupported())try{r=this._agents.desktop.create(i,t);}catch(e){var s=this._currentId,c=this.config().serviceWorker;this._agents.chrome.isSupported()&&this._agents.chrome.create(s,i,t,c,function(i){return o._serviceWorkerCallback(i,t,n)});}else this._agents.webkit.isSupported()?r=this._agents.webkit.create(i,t):this._agents.firefox.isSupported()?this._agents.firefox.create(i,t):this._agents.ms.isSupported()?r=this._agents.ms.create(i,t):(t.title=i,this.config().fallback(t));if(null!==r){var a=this._addNotification(r),u=this._prepareNotification(a,t);f.isFunction(t.onShow)&&r.addEventListener("show",t.onShow),f.isFunction(t.onError)&&r.addEventListener("error",t.onError),f.isFunction(t.onClick)&&r.addEventListener("click",t.onClick),r.addEventListener("close",function(){e(a);}),r.addEventListener("cancel",function(){e(a);}),n(u);}n(null);}},{key:"create",value:function(t,n){var e,o=this;if(!f.isString(t))throw new Error(i.errors.invalid_title);return e=this.Permission.has()?function(i,e){try{o._createCallback(t,n,i);}catch(i){e(i);}}:function(e,r){o.Permission.request().then(function(){o._createCallback(t,n,e);}).catch(function(){r(i.errors.permission_denied);});},new Promise(e)}},{key:"count",value:function(){var i,t=0;for(i in this._notifications)this._notifications.hasOwnProperty(i)&&t++;return t}},{key:"close",value:function(i){var t;for(t in this._notifications)if(this._notifications.hasOwnProperty(t)&&this._notifications[t].tag===i)return this._closeNotification(t)}},{key:"clear",value:function(){var i,t=!0;for(i in this._notifications)this._notifications.hasOwnProperty(i)&&(t=t&&this._closeNotification(i));return t}},{key:"supported",value:function(){var i=!1;for(var t in this._agents)this._agents.hasOwnProperty(t)&&(i=i||this._agents[t].isSupported());return i}},{key:"config",value:function(i){return (void 0!==i||null!==i&&f.isObject(i))&&f.objectMerge(this._configuration,i),this._configuration}},{key:"extend",value:function(t){var n,e={}.hasOwnProperty;if(!e.call(t,"plugin"))throw new Error(i.errors.invalid_plugin);for(var o in e.call(t,"config")&&f.isObject(t.config)&&null!==t.config&&this.config(t.config),n=new(t.plugin)(this.config()))e.call(n,o)&&f.isFunction(n[o])&&(this[o]=n[o]);}}]),t}())("undefined"!=typeof window?window:commonjsGlobal)});
	
} (push_min));

var push_minExports = push_min.exports;
const Push = /*@__PURE__*/getDefaultExportFromCjs(push_minExports);

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _booted, _bus, _ls, _cron, _identity, _api, _firebaseApp, _firebaseMessaging, _serviceWorkerRegistration, _serviceWorkerRegistrationToken, _pushPermission, _doNotAskForPermissionPreference, _canRequestPermission, _canPush, _onAuthenticatedForFirebase, _onUnauthenticatedForFirebase, _serviceWorkerPath, _serviceWorkerMode, _serviceWorkerState, _serviceWorkerRegistrationWatchStopHandle, _serviceWorkerRegistrationTokenWatchStopHandle, _pushPermissionWatchStopHandle, _doNotAskForPermissionPreferenceWatchStopHandle, _identityAuthenticatedWatchStopHandle, _apiFirebaseOperationAbortController, _fcmOnMessageUnsubscribe, _updateServiceWorkerState, updateServiceWorkerState_fn, _doUpdates, doUpdates_fn, _update, update_fn, _updateFcmToken, updateFcmToken_fn, _updateApiAboutFirebase, updateApiAboutFirebase_fn, _onServiceWorkerInstall, onServiceWorkerInstall_fn;
const debug = getDebugger("Push");
const fbug = getDebugger("Firebase", "#1B3A57", "#FFCA28");
const sbug = getDebugger("Service Worker");
class PushService {
  /**
   * Create a new PushService instance.
   * @param bus The BusService instance to use for communication
   * @param ls The LocalStorageService instance to use for storing and retrieving preferences and tokens
   * @param cron The MiliCron instance to use for scheduling updates
   * @param identity The IdentityService instance to use for determining if the user is authenticated
   * @param firebaseOptions The options to use for initializing Firebase
   * @param onAuthenticatedForFirebase The callback to use for storing the Firebase Messaging Token in an external service when the user is authenticated
   * @param onUnauthenticatedForFirebase The callback to use for removing the Firebase Messaging Token from an external service when the user is unauthenticated
   * @param serviceWorkerPath The path to the service worker to use for handling push notifications
   * @param serviceWorkerMode The mode to use for the service worker
   */
  constructor(bus, ls, cron, identity, api, firebaseOptions, onAuthenticatedForFirebase, onUnauthenticatedForFirebase, serviceWorkerPath, serviceWorkerMode) {
    /**
     * Update the service worker state reference so we can do things based on it.
     */
    __privateAdd(this, _updateServiceWorkerState);
    __privateAdd(this, _doUpdates);
    __privateAdd(this, _update);
    __privateAdd(this, _updateFcmToken);
    __privateAdd(this, _updateApiAboutFirebase);
    __privateAdd(this, _onServiceWorkerInstall);
    __privateAdd(this, _booted, void 0);
    __privateAdd(this, _bus, void 0);
    __privateAdd(this, _ls, void 0);
    __privateAdd(this, _cron, void 0);
    __privateAdd(this, _identity, void 0);
    __privateAdd(this, _api, void 0);
    __privateAdd(this, _firebaseApp, void 0);
    __privateAdd(this, _firebaseMessaging, void 0);
    __privateAdd(this, _serviceWorkerRegistration, void 0);
    __privateAdd(this, _serviceWorkerRegistrationToken, void 0);
    __privateAdd(this, _pushPermission, void 0);
    __privateAdd(this, _doNotAskForPermissionPreference, void 0);
    __privateAdd(this, _canRequestPermission, void 0);
    __privateAdd(this, _canPush, void 0);
    __privateAdd(this, _onAuthenticatedForFirebase, void 0);
    __privateAdd(this, _onUnauthenticatedForFirebase, void 0);
    __privateAdd(this, _serviceWorkerPath, void 0);
    __privateAdd(this, _serviceWorkerMode, void 0);
    __privateAdd(this, _serviceWorkerState, void 0);
    __privateAdd(this, _serviceWorkerRegistrationWatchStopHandle, void 0);
    __privateAdd(this, _serviceWorkerRegistrationTokenWatchStopHandle, void 0);
    __privateAdd(this, _pushPermissionWatchStopHandle, void 0);
    __privateAdd(this, _doNotAskForPermissionPreferenceWatchStopHandle, void 0);
    __privateAdd(this, _identityAuthenticatedWatchStopHandle, void 0);
    __privateAdd(this, _apiFirebaseOperationAbortController, void 0);
    __privateAdd(this, _fcmOnMessageUnsubscribe, void 0);
    if (!(bus instanceof BusService)) {
      throw new Error("Invalid or missing BusService instance");
    }
    if (!(ls instanceof LocalStorageService)) {
      throw new Error("Invalid or missing LocalStorageService instance");
    }
    if (!(cron instanceof MiliCron)) {
      throw new Error("Invalid or missing MiliCron instance");
    }
    if (!(identity instanceof IdentityService)) {
      throw new Error("Invalid or missing IdentityService instance");
    }
    if (!isAxiosInstance(api)) {
      throw new Error("Invalid or missing ApiService instance");
    }
    __privateSet(this, _booted, ref(false));
    __privateSet(this, _serviceWorkerState, ref(void 0));
    __privateSet(this, _bus, bus);
    __privateSet(this, _ls, ls);
    __privateSet(this, _cron, cron);
    __privateSet(this, _identity, identity);
    __privateSet(this, _api, api);
    __privateSet(this, _serviceWorkerRegistration, ref(void 0));
    __privateSet(this, _serviceWorkerRegistrationToken, ref(void 0));
    __privateSet(this, _pushPermission, ref(void 0));
    __privateSet(this, _doNotAskForPermissionPreference, ref(void 0));
    __privateSet(this, _onAuthenticatedForFirebase, onAuthenticatedForFirebase);
    __privateSet(this, _onUnauthenticatedForFirebase, onUnauthenticatedForFirebase);
    __privateSet(this, _serviceWorkerPath, serviceWorkerPath);
    __privateSet(this, _serviceWorkerMode, serviceWorkerMode);
    __privateSet(this, _canRequestPermission, computed(() => {
      if (true === __privateGet(this, _doNotAskForPermissionPreference).value || void 0 === __privateGet(this, _doNotAskForPermissionPreference).value) {
        return false;
      }
      switch (__privateGet(this, _pushPermission).value) {
        case Push.Permission.DEFAULT:
          return true;
        default:
          return false;
      }
    }));
    __privateSet(this, _canPush, computed(() => {
      switch (__privateGet(this, _pushPermission).value) {
        case Push.Permission.DENIED:
          return false;
        case Push.Permission.GRANTED:
          return true;
        case Push.Permission.DEFAULT:
          return null;
        default:
          return false;
      }
    }));
    try {
      __privateSet(this, _firebaseApp, initializeApp(firebaseOptions));
    } catch (error) {
      fbug("Failed to Initialize Firebase Application", error.message);
    }
    if (__privateGet(this, _firebaseApp)) {
      try {
        __privateSet(this, _firebaseMessaging, getMessaging(__privateGet(this, _firebaseApp)));
      } catch (error) {
        fbug("Failed to Initialize Firebase Messaging", error.message);
      }
    }
    if (__privateGet(this, _firebaseApp) && __privateGet(this, _firebaseMessaging)) {
      fbug("Firebase Application & Messaging Initialized");
    } else {
      fbug("Firebase Application & Messaging Skipped");
    }
  }
  /**
   * Whether or not the service has been booted.
   */
  get booted() {
    return __privateGet(this, _booted);
  }
  /**
   * Whether or not the UI should show a prompt for the user to allow push notifications.
   */
  get canRequestPermission() {
    return __privateGet(this, _canRequestPermission);
  }
  /**
   * Whether or not permissions have been granted for push notifications.
   */
  get canPush() {
    return __privateGet(this, _canPush);
  }
  /**
   * The current state of the service worker.
   */
  get serviceWorkerState() {
    return computed(() => __privateGet(this, _serviceWorkerState).value);
  }
  /**
   * If there is an update pending for the service worker.
   */
  get appUpdatePending() {
    return computed(() => __privateGet(this, _serviceWorkerState).value === "waiting");
  }
  /**
   * Request permission to show push notifications.
   */
  requestPushPermission() {
    Push.Permission.request(
      () => {
        debug("Push Permission Granted");
        __privateGet(this, _bus).emit("push:updated", { local: true, crossTab: true });
        __privateGet(this, _bus).emit("push:permission:granted", { local: true, crossTab: true });
      },
      () => {
        debug("Push Permission Denied");
        __privateGet(this, _bus).emit("push:updated", { local: true, crossTab: true });
        __privateGet(this, _bus).emit("push:permission:denied", { local: true, crossTab: true });
      }
    );
  }
  /**
   * Stop asking the user for permission to show push notifications.
   * @returns void
   */
  doNotRequestPushPermission() {
    if (this.canPush.value) {
      return;
    }
    __privateGet(this, _ls).set("push.donotaskforpermission", true);
    __privateGet(this, _bus).emit("push:updated", { local: true, crossTab: true });
  }
  /**
   * Create a web push notification (otherwise known as a desktop notification).
   * @param options The options for the web push notification
   */
  createWebPushNotification(options) {
    if (!this.canPush.value) {
      return;
    }
    const opts = {
      body: options.body,
      icon: options.icon,
      link: options.link,
      requireInteraction: options.requireInteraction,
      timeout: options.timeout,
      vibrate: options.vibrate,
      silent: options.silent,
      onClick: function(event) {
        debug("Web Push Notification Clicked", event);
        if (options.onClick) {
          options.onClick(event);
        }
        if (options.closeOnClick) {
          window.focus();
          this.close();
        }
      },
      onClose: function(event) {
        debug("Web Push Notification Closed", event);
        if (options.onClose) {
          options.onClose(event);
        }
      },
      onError: function(error) {
        debug("Web Push Notification Error", error);
        if (options.onError) {
          options.onError(error);
        }
      },
      onShow: function(event) {
        debug("Web Push Notification Shown", event);
        if (options.onShow) {
          options.onShow(event);
        }
      }
    };
    try {
      Push.create(options.title, opts);
    } catch (error) {
      debug("Web Push Notification Error", error);
    }
  }
  /**
   * Reset the preference to ask the user for permission to show push notifications.
   * @private
   * @returns void
   * @remarks This is a function that should only be used for development and testing purposes.
   */
  $resetDoNotRequestPushPermissionPreference() {
    __privateGet(this, _ls).remove("push.donotaskforpermission");
    __privateGet(this, _bus).emit("push:updated", { local: true, crossTab: true });
  }
  /**
   * Boot the service.
   */
  boot() {
    if (__privateGet(this, _booted).value) {
      return;
    }
    debug("Booting");
    const booted = () => {
      __privateGet(this, _booted).value = true;
      debug("Booted");
    };
    __privateSet(this, _serviceWorkerRegistrationWatchStopHandle, watch(
      () => __privateGet(this, _serviceWorkerRegistration).value,
      (is, was) => {
        if (was === is) {
          return;
        }
        debug("Service Worker Registration Changed", { was, is });
        if (is) {
          __privateMethod(this, _updateFcmToken, updateFcmToken_fn).call(this);
        } else if (!__privateGet(this, _serviceWorkerRegistrationToken).value) {
          fbug("Skipped generating Firebase Messaging Token", {
            canPush: this.canPush.value,
            serviceWorkerRegistration: "undefined" !== typeof __privateGet(this, _serviceWorkerRegistration).value
          });
        }
      },
      {
        immediate: true,
        deep: true
      }
    ));
    __privateSet(this, _serviceWorkerRegistrationTokenWatchStopHandle, watch(
      () => __privateGet(this, _serviceWorkerRegistrationToken).value,
      (is, was) => {
        if (was === is) {
          return;
        }
        fbug("Notifying of Firebase Messaging Token Update", { token: is });
        __privateGet(this, _bus).emit("firebase:token:updated", { local: true, crossTab: true }, is);
        __privateMethod(this, _updateApiAboutFirebase, updateApiAboutFirebase_fn).call(this);
      },
      {
        immediate: true,
        deep: true
      }
    ));
    __privateSet(this, _pushPermissionWatchStopHandle, watch(
      () => __privateGet(this, _pushPermission).value,
      (is, was) => {
        if (was === is) {
          return;
        }
        debug("Push Permission Changed", { was, is });
        if (this.canPush.value && __privateGet(this, _serviceWorkerRegistration).value) {
          __privateMethod(this, _updateFcmToken, updateFcmToken_fn).call(this);
        } else if (!__privateGet(this, _serviceWorkerRegistrationToken).value) {
          fbug("Skipped generating Firebase Messaging Token", {
            canPush: this.canPush.value,
            serviceWorkerRegistration: "undefined" !== typeof __privateGet(this, _serviceWorkerRegistration).value
          });
        }
      },
      {
        immediate: true,
        deep: true
      }
    ));
    __privateSet(this, _doNotAskForPermissionPreferenceWatchStopHandle, watch(
      () => __privateGet(this, _doNotAskForPermissionPreference).value,
      (is, was) => {
        if (was === is) {
          return;
        }
        debug("Do Not Ask For Permission Preference Changed", { was, is });
      },
      {
        immediate: true,
        deep: true
      }
    ));
    __privateSet(this, _identityAuthenticatedWatchStopHandle, watch(
      () => __privateGet(this, _identity).authenticated.value,
      (is, was) => {
        if (was === is) {
          return;
        }
        __privateMethod(this, _updateApiAboutFirebase, updateApiAboutFirebase_fn).call(this);
      },
      {
        immediate: true,
        deep: true
      }
    ));
    __privateGet(this, _cron).$on("*/250 * * * * *", __privateMethod(this, _update, update_fn).bind(this));
    __privateGet(this, _bus).on("push:updated", __privateMethod(this, _update, update_fn).bind(this), { local: true, crossTab: true });
    __privateGet(this, _bus).on("sw:install", __privateMethod(this, _onServiceWorkerInstall, onServiceWorkerInstall_fn).bind(this), {
      local: true,
      crossTab: true
    });
    __privateMethod(this, _doUpdates, doUpdates_fn).call(this, true);
    if ("undefined" !== typeof window && "undefined" !== typeof navigator && "serviceWorker" in navigator) {
      if ("undefined" === typeof __privateGet(this, _serviceWorkerRegistration).value) {
        if (!__privateGet(this, _serviceWorkerPath) || !__privateGet(this, _serviceWorkerMode)) {
          debug("Service Worker Path or Mode not set, skipping registration");
          return booted();
        }
        debug("Attempting to register Service Worker", {
          path: __privateGet(this, _serviceWorkerPath),
          mode: __privateGet(this, _serviceWorkerMode)
        });
        navigator.serviceWorker.register(__privateGet(this, _serviceWorkerPath), { type: __privateGet(this, _serviceWorkerMode) }).then((registration) => {
          sbug("Service Worker Registered", registration);
          __privateGet(this, _serviceWorkerRegistration).value = registration;
        }).catch((error) => {
          sbug("Service Worker Registration Failed", error);
        });
      }
      navigator.serviceWorker.addEventListener("message", (event) => {
        sbug("Got new message from service worker", event.data);
        if (event.data.messageType === "push-received" && event.data.data && event.data.data.event) {
          sbug("Got push notification from service worker", event.data.data);
          const { event: pushEvent, detail } = event.data.data;
          const busEvent = `background:${pushEvent}`;
          __privateGet(this, _bus).emit(busEvent, { local: true }, detail);
        }
        if (event.data.messageType === "sw-received" && event.data.data && event.data.data.event) {
          sbug("Got event from service worker", event.data.data);
          const { event: pushEvent, detail } = event.data.data;
          const busEvent = `background:${pushEvent}`;
          __privateGet(this, _bus).emit(busEvent, { local: true }, detail);
        }
        if (event.data.notification) {
          __privateGet(this, _bus).emit("push:notification", { local: true }, event.data.notification);
        }
      });
      navigator.serviceWorker.addEventListener("messageerror", (event) => {
        sbug("Got new message error from service worker", event.data);
      });
      navigator.serviceWorker.ready.then((registration) => {
        sbug("Service Worker Ready", registration);
        __privateGet(this, _serviceWorkerRegistration).value = registration;
        __privateMethod(this, _updateServiceWorkerState, updateServiceWorkerState_fn).call(this, registration);
      });
      navigator.serviceWorker.addEventListener("controllerchange", (event) => {
        sbug("Service Worker saw Controller Change", event);
      });
    }
    if (__privateGet(this, _firebaseMessaging)) {
      __privateSet(this, _fcmOnMessageUnsubscribe, onMessage(__privateGet(this, _firebaseMessaging), (payload) => {
        __privateGet(this, _bus).emit("push:firebase:message", { local: true }, payload);
        fbug("Got Firebase Messaging Payload", payload);
        if (payload.data && payload.data.event) {
          const { event: pushEvent, detail } = payload.data;
          const busEvent = `background:${pushEvent}`;
          __privateGet(this, _bus).emit(busEvent, { local: true }, detail);
        }
      }));
      fbug("Firebase Messaging On Message Subscribed");
    }
    return booted();
  }
  /**
   * Shut down the service.
   */
  shutdown() {
    if (!__privateGet(this, _booted).value) {
      return;
    }
    debug("Shutting Down");
    __privateGet(this, _bus).off("push:updated", __privateMethod(this, _update, update_fn).bind(this), { local: true, crossTab: true });
    __privateGet(this, _bus).off("sw:install", __privateMethod(this, _onServiceWorkerInstall, onServiceWorkerInstall_fn).bind(this), {
      local: true,
      crossTab: true
    });
    __privateGet(this, _cron).$off("*/250 * * * * *", __privateMethod(this, _update, update_fn).bind(this));
    if (__privateGet(this, _serviceWorkerRegistrationWatchStopHandle)) {
      __privateGet(this, _serviceWorkerRegistrationWatchStopHandle).call(this);
    }
    if (__privateGet(this, _serviceWorkerRegistrationTokenWatchStopHandle)) {
      __privateGet(this, _serviceWorkerRegistrationTokenWatchStopHandle).call(this);
    }
    if (__privateGet(this, _pushPermissionWatchStopHandle)) {
      __privateGet(this, _pushPermissionWatchStopHandle).call(this);
    }
    if (__privateGet(this, _doNotAskForPermissionPreferenceWatchStopHandle)) {
      __privateGet(this, _doNotAskForPermissionPreferenceWatchStopHandle).call(this);
    }
    if (__privateGet(this, _identityAuthenticatedWatchStopHandle)) {
      __privateGet(this, _identityAuthenticatedWatchStopHandle).call(this);
    }
    if (__privateGet(this, _apiFirebaseOperationAbortController)) {
      __privateGet(this, _apiFirebaseOperationAbortController).abort();
    }
    if (__privateGet(this, _fcmOnMessageUnsubscribe)) {
      __privateGet(this, _fcmOnMessageUnsubscribe).call(this);
    }
    debug("Shut Down");
  }
  async update() {
    if (!("undefined" !== typeof window && "undefined" !== typeof navigator && "serviceWorker" in navigator)) {
      debug("Not in a context with a Service Worker");
      return;
    }
    if (!this.appUpdatePending.value) {
      debug("No Service Worker Update Pending");
      return;
    }
    const registration = await navigator.serviceWorker.ready;
    if (!registration.waiting) {
      debug("No Waiting Service Worker");
      return;
    }
    const finished = new Promise((resolve) => {
      navigator.serviceWorker.addEventListener("controllerchange", resolve, { once: true });
    });
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
    await finished;
    if (window && window.location) {
      window.location.reload();
    } else {
      debug("Finished waiting for Service Worker to update");
    }
  }
}
_booted = new WeakMap();
_bus = new WeakMap();
_ls = new WeakMap();
_cron = new WeakMap();
_identity = new WeakMap();
_api = new WeakMap();
_firebaseApp = new WeakMap();
_firebaseMessaging = new WeakMap();
_serviceWorkerRegistration = new WeakMap();
_serviceWorkerRegistrationToken = new WeakMap();
_pushPermission = new WeakMap();
_doNotAskForPermissionPreference = new WeakMap();
_canRequestPermission = new WeakMap();
_canPush = new WeakMap();
_onAuthenticatedForFirebase = new WeakMap();
_onUnauthenticatedForFirebase = new WeakMap();
_serviceWorkerPath = new WeakMap();
_serviceWorkerMode = new WeakMap();
_serviceWorkerState = new WeakMap();
_serviceWorkerRegistrationWatchStopHandle = new WeakMap();
_serviceWorkerRegistrationTokenWatchStopHandle = new WeakMap();
_pushPermissionWatchStopHandle = new WeakMap();
_doNotAskForPermissionPreferenceWatchStopHandle = new WeakMap();
_identityAuthenticatedWatchStopHandle = new WeakMap();
_apiFirebaseOperationAbortController = new WeakMap();
_fcmOnMessageUnsubscribe = new WeakMap();
_updateServiceWorkerState = new WeakSet();
updateServiceWorkerState_fn = function(registration) {
  if (registration) {
    switch (true) {
      case null !== registration.installing:
        __privateGet(this, _serviceWorkerState).value = "installing";
        break;
      case null !== registration.waiting:
        __privateGet(this, _serviceWorkerState).value = "waiting";
        break;
      case null !== registration.active:
        __privateGet(this, _serviceWorkerState).value = "activated";
        break;
    }
    return;
  }
  if ("undefined" !== typeof window && "undefined" !== typeof navigator && "serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration2) => {
      __privateMethod(this, _updateServiceWorkerState, updateServiceWorkerState_fn).call(this, registration2);
    });
  }
};
_doUpdates = new WeakSet();
doUpdates_fn = function(first = false) {
  if (!__privateGet(this, _ls).loaded) {
    if (first) {
      __privateGet(this, _ls).promise.then(() => {
        __privateMethod(this, _doUpdates, doUpdates_fn).call(this, first);
      });
    }
    return;
  }
  const doNotAskForPermission = __privateGet(this, _ls).get("push.donotaskforpermission") || false;
  __privateGet(this, _doNotAskForPermissionPreference).value = doNotAskForPermission;
  __privateGet(this, _pushPermission).value = Push.Permission.get();
  __privateMethod(this, _updateServiceWorkerState, updateServiceWorkerState_fn).call(this);
};
_update = new WeakSet();
update_fn = function() {
  __privateMethod(this, _doUpdates, doUpdates_fn).call(this);
};
_updateFcmToken = new WeakSet();
updateFcmToken_fn = function() {
  if (!__privateGet(this, _serviceWorkerRegistration).value || !this.canPush.value) {
    return;
  }
  if (__privateGet(this, _serviceWorkerRegistrationToken).value) {
    return;
  }
  getToken(__privateGet(this, _firebaseMessaging), {
    serviceWorkerRegistration: __privateGet(this, _serviceWorkerRegistration).value
  }).then((token) => {
    if (token) {
      fbug("Firebase Messaging Token", token);
      __privateGet(this, _serviceWorkerRegistrationToken).value = token;
      if (__privateGet(this, _ls).loaded) {
        __privateGet(this, _ls).set("push.serviceworker.registration.token", token);
      } else {
        __privateGet(this, _ls).promise.then(() => {
          __privateGet(this, _ls).set("push.serviceworker.registration.token", token);
        });
      }
    } else {
      fbug("No Firebase Messaging Token");
    }
  }).catch((error) => {
    fbug("Error retreiving Firebase Messaging Token", error);
  });
};
_updateApiAboutFirebase = new WeakSet();
updateApiAboutFirebase_fn = function() {
  if (__privateGet(this, _serviceWorkerRegistrationToken).value) {
    const is = __privateGet(this, _identity).authenticated.value;
    if (__privateGet(this, _apiFirebaseOperationAbortController)) {
      __privateGet(this, _apiFirebaseOperationAbortController).abort();
    }
    __privateSet(this, _apiFirebaseOperationAbortController, new AbortController());
    try {
      if (is) {
        ;
        (async () => {
          fbug("Registering Firebase Messaging Token");
          try {
            await __privateGet(this, _onAuthenticatedForFirebase).call(this, __privateGet(this, _serviceWorkerRegistrationToken).value, __privateGet(this, _api), __privateGet(this, _apiFirebaseOperationAbortController).signal);
            fbug("Registered Firebase Messaging Token");
          } catch (error) {
            if (error instanceof Error && error.name !== "CancelError" || !(error instanceof Error)) {
              fbug("Failed to register Firebase Messaging Token", error);
            }
          }
        })();
      } else {
        ;
        (async () => {
          fbug("Unregistering Firebase Messaging Token");
          try {
            await __privateGet(this, _onUnauthenticatedForFirebase).call(this, __privateGet(this, _serviceWorkerRegistrationToken).value, __privateGet(this, _api), __privateGet(this, _apiFirebaseOperationAbortController).signal);
            fbug("Unregistered Firebase Messaging Token");
          } catch (error) {
            if (error instanceof Error && error.name !== "CancelError" || !(error instanceof Error)) {
              fbug("Failed to unregister Firebase Messaging Token", error);
            }
          }
        })();
      }
    } catch (error) {
      if (error instanceof Error && error.name !== "CancelError") {
        fbug("API Firebase Operation threw and Error", error);
      }
    }
  }
};
_onServiceWorkerInstall = new WeakSet();
onServiceWorkerInstall_fn = function(event) {
  sbug("Service Worker Installed might be waiting", event);
  __privateMethod(this, _updateServiceWorkerState, updateServiceWorkerState_fn).call(this);
};

const push = {
  __proto__: null,
  PushService: PushService
};

export { PushService as P, push as p };
//# sourceMappingURL=vueprint.c9f38640.mjs.map
